var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import JetInput from "@/Jetstream/Input";
import JetButton from "@/Jetstream/Button";
import JetLabel from "@/Jetstream/Label";
import useForm from "@/Utils/useForm";
import { PlusCircleIcon } from "@heroicons/react/24/outline";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import { useRoute } from 'ziggy-js';
import { Ziggy } from '@/ziggy.js';
export default function CustomFieldsForm(_a) {
    var team = _a.team, onClose = _a.onClose;
    var route = useRoute(Ziggy);
    var form = useForm({
        custom_fields: team.custom_fields.filter(function (field) { return field.type === 'App\\Models\\Branch'; })
    });
    function addField() {
        form.data.custom_fields.push({});
        form.setData('custom_fields', form.data.custom_fields);
    }
    function removeField(field) {
        // find the field and remove it
        form.data.custom_fields = form.data.custom_fields.filter(function (f) { return f !== field; });
        form.setData('custom_fields', form.data.custom_fields);
    }
    function submit() {
        form.post(route('team.custom-fields.update', { team: team, type: "branch" }), {
            preserveState: false
        });
    }
    function close() {
    }
    function setCustomFieldValue(idx, key, value) {
        form.data.custom_fields[idx][key] = value;
        form.setData('custom_fields', form.data.custom_fields);
    }
    return _jsxs("div", __assign({ className: "px-6 py-6" }, { children: [_jsx("h3", __assign({ className: "font-bold text-lg mb-4" }, { children: "Custom fields" })), _jsx("p", __assign({ className: "text-sm text-gray-500 mb-4" }, { children: "Custom fields allow you to store additional information about a branch" })), form.data.custom_fields.map(function (field, idx) { return _jsxs("div", __assign({ className: "flex gap-4 mb-4" }, { children: [_jsx("div", __assign({ className: "w-1/3 flex items-center" }, { children: _jsx(JetLabel, { htmlFor: field.name, value: "Custom Field #".concat(idx + 1) }) })), _jsx(JetInput, { id: field.name, type: "text", placeholder: "Field name...", className: "mt-1 block w-full", value: field.name, onChange: function (e) { return setCustomFieldValue(idx, 'name', e.currentTarget.value); } }), _jsx("button", __assign({ onClick: function () { return removeField(field); }, className: "text-sm text-red-500" }, { children: "Remove" }))] }), idx); }), _jsx("div", __assign({ className: "flex justify-center mb-2" }, { children: _jsxs(JetSecondaryButton, __assign({ disabled: form.data.custom_fields.length === 3, onClick: addField }, { children: [_jsx(PlusCircleIcon, { className: "h-4 w-4 inline-block mr-2" }), "Add custom field"] })) })), _jsxs("div", __assign({ className: "flex justify-center mb-4 text-sm text-gray-500 mb-4" }, { children: [form.data.custom_fields.length, "/3 custom fields added"] })), _jsxs("div", { children: [_jsx(JetButton, __assign({ onClick: submit, className: "mr-4" }, { children: "Save" })), _jsx(JetSecondaryButton, __assign({ onClick: onClose }, { children: "Close" }))] })] }));
}
